/**
 * Returns the "security" Redux state.
 *
 * It is mainly information about the currently authenticated user.
 *
 * @param state The redux state.
 */
export const getSecurityContext = state => (
  state.securityContext
);

export const getUsers = state => (
  state.users
);

export const getUser = state => (
  state.user
);

export const getProfiles = state => (
  state.profiles
);

export const getDocuments = state => (
  state.documents
);

export const getDocument = state => (
  state.document
);

export const getRegions = state => (
  state.regions
);

export const getAdminRegions = state => (
  state.adminRegions
);

export const getAgencies = state => (
  state.agencies
);

export const getAdminAgencies = state => (
  state.adminAgencies
);

export const getFunctions = state => (
  state.functions
);

export const getCategories = state => (
  state.categories
);

export const getConfirmDialog = state => (
  state.confirmDialog
);

export const getNews = state => (
  state.news
);

export const getFunctionGroups = state => (
  state.functionGroups
);

export const getUserGroups = state => (
  state.userGroups
);

export const getRoadmaps = state => (
  state.roadmaps
);

export const getRoadmap = state => (
  state.roadmap
);

export const getRouteNextLocation = state => (
  state.routing.locationBeforeTransitions.state ? state.routing.locationBeforeTransitions.state.nextPathname : '/'
);



// WEBPACK FOOTER //
// ./shared/src/selectors/selectors.js